<template>
  <div class="painel-login-container">
    <div class="painel-login-card">
      <h1 class="painel-login-title">Painel de Controle das Salas de Atendimento</h1>
      
      <form class="painel-login-form" @submit.prevent="handleLogin">
        <div class="painel-form-group">
          <label for="clientCode">Login *</label>
          <input
            id="clientCode"
            v-model="form.clientCode"
            type="text"
            required
            placeholder=""
            autocomplete="username"
            :disabled="loading"
          />
        </div>

        <div class="painel-form-group">
          <label for="clientPassword">Senha *</label>
          <div class="painel-password-field">
            <input
              id="clientPassword"
              v-model="form.clientPassword"
              :type="showPassword ? 'text' : 'password'"
              required
              placeholder=""
              autocomplete="current-password"
              :disabled="loading"
            />
            <button
              type="button"
              class="painel-password-toggle"
              :aria-label="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
              :title="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
              :aria-pressed="showPassword ? 'true' : 'false'"
              :disabled="loading"
              @click="showPassword = !showPassword"
            >
              <IconVisibility :visible="showPassword" />
            </button>
          </div>
        </div>

        <button type="submit" class="painel-btn-entrar" :disabled="loading">
          {{ loading ? 'Entrando...' : 'Entrar' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { loginCliente, isAuthenticated } from '../service/auth.service';
import { showErrorToast } from '../service/toast.service';
import IconVisibility from '@/assets/icons/IconVisibility.vue';

export default {
  name: 'PainelLogin',

  components: {
    IconVisibility
  },

  data() {
    return {
      form: {
        clientCode: '',
        clientPassword: ''
      },
      showPassword: false,
      loading: false
    };
  },

  mounted() {
    if (isAuthenticated()) {
      this.$router.replace('/painel/dashboard');
    }
  },

  methods: {
    async handleLogin() {
      this.loading = true;

      try {
        await loginCliente({
          codigo: this.form.clientCode.trim(),
          senha: this.form.clientPassword
        });
        this.$router.push('/painel/dashboard');
      } catch (err) {
        showErrorToast('Código ou senha incorretos. Verifique seus dados e tente novamente.');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped src="./PainelLogin.css"></style>
